import { defineStore } from "pinia";

export const useBalanceStore = defineStore('balance', {
    state: () => ({
        balance: {},
        balances: [],
    }),
    actions: {
        setBalance(balance) {
            this.balance = balance
        },
        setBalances(balances) {
            this.balances = balances
        },
        addBalance(balance) {
            this.balances.unshift(balance)
        },
        updateBalance(balance) {
            let index = this.balances.findIndex(cl => cl.id === balance.id)
            this.balances.splice(index, 1, balance)
        },
        deleteBalance(balance) {
            let index = this.balances.findIndex(cl => cl.id === balance.id)
            this.balances.splice(index, 1)
        },
    },
});